module.exports = __webpack_public_path__ + "img/p5.b9dd0c76.png";